import { render, staticRenderFns } from "./DuplicatePrices.vue?vue&type=template&id=65a036a6&"
import script from "./DuplicatePrices.vue?vue&type=script&lang=js&"
export * from "./DuplicatePrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports